import React from 'react';
import '../styles/Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>Copyright 2026 Struggle</p>
    </footer>
  );
}